module.exports = __webpack_public_path__ + "static/media/external-contact.391ea9ba.png";